import { Link } from 'react-router-dom';

interface ProgramCardData {
  slug: string;
  name: string;
  days: number;
  classLengthShort: string;
  cardImage: string;
}

interface ProgramsGridProps {
  programs: ProgramCardData[];
  isLoading?: boolean;
}

export function ProgramsGrid({ programs, isLoading }: ProgramsGridProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        <span className="ml-2 text-gray-600">Cargando programas...</span>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 px-4 md:px-0">
      <div className="space-y-4">
        {programs.slice(0, 2).map((program, idx) => (
          <div key={`p1-${idx}`} className="relative h-48 bg-cover bg-center rounded-lg" style={{ backgroundImage: `url("https://image.beholos.com/600x500/filters:quality(90)${program.cardImage}")` }}>
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-lg"></div>
            <div className="absolute bottom-4 left-4 text-white">
              <div className="text-sm md:text-xs font-bold mb-1">{program.classLengthShort}/{program.days}días</div>
              <div className="text-base md:text-sm font-bold mb-2 leading-snug">{program.name}</div>
              <Link to={`/programas/${program.slug}`} className="text-holos-dark font-bold text-sm md:text-xs hover:text-holos flex justify-start md:justify-center items-center">
                Ver programa
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
              </Link>
            </div>
          </div>
        ))}
      </div>

      <div className="h-100">
        {programs[2] && (
          <div className="relative h-full bg-cover bg-center rounded-lg" style={{ backgroundImage: `url("https://image.beholos.com/600x500/filters:quality(90)${programs[2].cardImage}")` }}>
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-lg"></div>
            <div className="absolute bottom-4 left-4 text-white">
              <div className="text-sm md:text-xs font-bold mb-1">{programs[2].classLengthShort}/{programs[2].days}días</div>
              <div className="text-base md:text-sm font-bold mb-2 leading-snug">{programs[2].name}</div>
              <Link to={`/programas/${programs[2].slug}`} className="text-holos-dark font-bold text-sm md:text-xs hover:text-holos flex justify-start md:justify-center items-center">
                Ver programa
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
              </Link>
            </div>
          </div>
        )}
      </div>

      <div className="space-y-4">
        {programs.slice(3, 5).map((program, idx) => (
          <div key={`p3-${idx}`} className="relative h-48 bg-cover bg-center rounded-lg" style={{ backgroundImage: `url("https://image.beholos.com/600x500/filters:quality(90)${program.cardImage}")` }}>
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-lg"></div>
            <div className="absolute bottom-4 left-4 text-white">
              <div className="text-sm md:text-xs font-bold mb-1">{program.classLengthShort}/{program.days}días</div>
              <div className="text-base md:text-sm font-bold mb-2 leading-snug">{program.name}</div>
              <Link to={`/programas/${program.slug}`} className="text-holos-dark font-bold text-sm md:text-xs hover:text-holos flex justify-start md:justify-center items-center">
                Ver programa
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
              </Link>
            </div>
          </div>
        ))}
      </div>

      <div className="h-100">
        {programs[5] && (
          <div className="relative h-full bg-cover bg-center rounded-lg" style={{ backgroundImage: `url("https://image.beholos.com/600x500/filters:quality(90)${programs[5].cardImage}")` }}>
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-lg"></div>
            <div className="absolute bottom-4 left-4 text-white">
              <div className="text-sm md:text-xs font-bold mb-1">{programs[5].classLengthShort}/{programs[5].days}días</div>
              <div className="text-base md:text-sm font-bold mb-2 leading-snug">{programs[5].name}</div>
              <Link to={`/programas/${programs[5].slug}`} className="text-holos-dark font-bold text-sm md:text-xs hover:text-holos flex justify-start md:justify-center items-center">
                Ver programa
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


